import { getTitle, getName, DATASETS } from '../Constants';
import { searchContext } from '../../context/Context';
import { useState } from 'react';
import SideBarContent from '../QueriedContent/SideBarContent';
import { useNavigate, useLocation } from 'react-router-dom';
import updateParams from '../../utils/updateParams';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { XCircleIcon } from '@heroicons/react/24/outline';

export default function RenderInfoLogic({
  searchItems,
  selectedInfoItem,
  setSearchItems,
  isMapping,
  showModalExample: controlledShowModal,
  setShowModalExample: controlledSetShowModal,
  hideSearchItemsList = false,
}) {
  const { setSelectedInfoItem, view } = searchContext();
  const navigate = useNavigate();
  const location = useLocation();

  const [internalShowModal, setInternalShowModal] = useState(false);
  const [clickedItem, setClickedItem] = useState(null);

  const isControlled = controlledSetShowModal != null;
  const showModalExample = isControlled ? controlledShowModal : internalShowModal;
  const setShowModalExample = isControlled
    ? controlledSetShowModal
    : open => {
        setInternalShowModal(open);
        if (!open) setClickedItem(null);
      };

  const foundTitles = Array.isArray(searchItems) ? searchItems.map(item => getTitle(item)) : [];
  const ids = Array.isArray(searchItems) ? searchItems.map(item => getName(item)) : [];

  const handleOpenModal = item => {
    setSelectedInfoItem(item);
    setClickedItem(item);
    if (isControlled) controlledSetShowModal(true);
    else setInternalShowModal(true);
  };

  const handleClearAndCloseInfoDiv = (index: number) => {
    const searchParams = new URLSearchParams(location.search);
    const newIdents = searchParams.get('idents')?.split('-').filter((_, i) => i !== index) || [];
    if (newIdents.length === 0) {
      navigate('/');
    } else {
      const remainingSearchItems = searchItems.filter((_, i) => i !== index);
      const newParams = updateParams({
        searchItems: remainingSearchItems,
        view: searchParams.get('view') || undefined,
        source: searchParams.get('source') || undefined,
        tab: searchParams.get('tab') || undefined,
      });
      navigate({ pathname: location.pathname, search: newParams });
    }
  };

  return (
    <>
      {!hideSearchItemsList && foundTitles.length > 0 && ids.length > 0 && (
        <div className="col-8 titCab">
          {foundTitles.map((result, index) => (
            <div key={ids[index]}>
              <h4 className="titTabla d-flex">
                {ids[index] && <span className="mr-2">{[result, ids[index]].join(', ')}</span>}
                {result?.title !== DATASETS.ALL && !isMapping && (
                  <div className="d-flex align-items-center">
                    <div className="mr-2">
                      <button
                        data-testid="open-info-button"
                        onClick={() => handleOpenModal(searchItems[index])}
                      >
                        <i className="bi-info-circle" />
                      </button>
                    </div>
                    <div>
                      <button
                        data-testid="close-info-button"
                        onClick={() => handleClearAndCloseInfoDiv(index)}
                      >
                        <i className="bi-x-circle"></i>
                      </button>
                    </div>
                  </div>
                )}
              </h4>
            </div>
          ))}
        </div>
      )}
      {!hideSearchItemsList && <div className="col-6 titTabla"></div>}
      <SideBarContent
        selectedInfoItem={clickedItem ?? selectedInfoItem}
        view={view}
        showModalExample={showModalExample}
        setShowModalExample={setShowModalExample}
      />
    </>
  );
}
